export { DocumentPage, DocumentType } from './document-page';
export type { DocumentPageProps } from './document-page';
